import type {
  GetTreeNodeAssetMarkerProps,
  GetTreeNodeLocationMarkerProps,
  GetTreeNodeMarkerProps,
} from "./asset-tree-node-marker.type";

import { isAssetTreeNodeSector } from "@/modules/asset-tree";
import {
  getAssetMarker,
  getLocationMarker,
  getSectorMarker,
} from "@/modules/marker";

export const getTreeNodeMarker = ({
  context,
  node,
  conditionRatings,
}: GetTreeNodeMarkerProps) => {
  if (node.type === "location") {
    return getTreeNodeLocationMarker({ context, node });
  }

  if (node.type === "asset") {
    return getTreeNodeAssetMarker({ context, node, conditionRatings });
  }

  return null;
};

export const getTreeNodeLocationMarker = ({
  context,
  node,
}: GetTreeNodeLocationMarkerProps) => {
  const { id, name, position } = node;

  const props = { context, model: { id, name }, position };

  if (isAssetTreeNodeSector(node)) return getSectorMarker(props);

  return getLocationMarker(props);
};

export const getTreeNodeAssetMarker = ({
  context,
  node,
  conditionRatings,
}: GetTreeNodeAssetMarkerProps) => {
  const { id, name, position } = node;

  const color = conditionRatings.find(
    (value) => value.rating === node.condition_rating
  )?.color;

  return getAssetMarker({ context, model: { id, name }, position, color });
};
